import { useEffect } from "react";

const uns = (id, w = 1600) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;
const pex = (id, w = 1600) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const img = { uns, pex };

export function useTitle(title) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}

export const CONTACT = {
  email: "hello@urbantrail.co.in",
  phone: "+91 90510 44854",
  phoneHref: "tel:+919051044854",
  whatsapp: "https://wa.me/919051044854",
  office:
    "6th Floor, Park Plaza Building, 71, Park St, Taltala, Kolkata, West Bengal 700016",
  socials: [],
};

export const TEAM = [
  { name: "Shakib Siddique", designation: "Executive Director", photo: "/assets/team/shakib.jpg", bio: "" },
  { name: "Sumon Biswas", designation: "Head of Trade Partnership", photo: "/assets/team/sumon.jpg", bio: "" },
  { name: "Sritama Chandra", designation: "Head of Service Delivery", photo: "/assets/team/sritama.jpg", bio: "" },
  { name: "Soumi Das", designation: "Finance Executive", photo: null, bio: "" },
  { name: "Falguni Sarkar", designation: "Key Accounts Manager", photo: "/assets/team/falguni.jpg", bio: "" },
  { name: "Anjali Gupta", designation: "Senior Relationship Manager", photo: "/assets/team/anjali.jpg", bio: "" },
  { name: "Megha Das", designation: "Senior Relationship Manager", photo: "/assets/team/megha.jpg", bio: "" },
  { name: "Sneha Sharma", designation: "Senior Operation Manager", photo: "/assets/team/sneha.jpg", bio: "" },
  { name: "Shreya Ghosh", designation: "Operations Executive", photo: "/assets/team/shreya.jpg", bio: "" },
  { name: "Subharty Bhattacharjee", designation: "B2B Growth Specialist", photo: "/assets/team/subharty.jpg", bio: "" },
];

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/destinations", label: "Destinations" },
  { to: "/careers", label: "Careers" },
  { to: "/journal", label: "Journal" },
];

export const IMAGES = {
  homeHero: pex(35408915, 2200),
  homeFeature: pex(30701907, 2000),
  finalCta: uns("photo-1619796696652-a29a854f21a0", 2200),
  aboutHero: pex(36908076, 2000),
  aboutPhilosophy: uns("photo-1687074106203-f3dad46d9eb6", 1800),
  destinationsHero: pex(29167628, 2000),
  careersHero: pex(28098320, 2000),
  careersLife: uns("photo-1707544929996-3f21c209c5e1", 1600),
  journalHero: pex(20824634, 2000),
  contactHero: uns("photo-1710314371306-11d0b0c1bd08", 2000),
};

export const EXPERIENCES = [
  {
    title: "Mountain Escapes",
    text: "Himalayan landscapes, mountain stays and slow journeys.",
    image: pex(8495440, 1400),
  },
  {
    title: "Cultural Journeys",
    text: "Local traditions, heritage, food and stories.",
    image: uns("photo-1628070018796-a9f4e2dd482a", 1400),
  },
  {
    title: "Luxury Escapes",
    text: "Beautiful stays, refined hospitality and private experiences.",
    image: pex(19829800, 1400),
  },
  {
    title: "Leisure & Discovery",
    text: "Relaxed journeys designed around exploration and discovery.",
    image: uns("photo-1546484475-7f7bd55792da", 1400),
  },
];

export const DESTINATIONS = [
  {
    slug: "sikkim",
    name: "Sikkim",
    region: "Domestic",
    tagline: "Where Himalayan landscapes, quiet monasteries and mountain culture come together.",
    cardImage: pex(12174800, 1400),
    heroImage: uns("photo-1590256518627-c9f8a6855185", 2200),
    heroTitle: ["Sikkim"],
    heroSub: "Where the Himalayas slow you down.",
    intro:
      "Sikkim is a destination of extraordinary contrasts — snow-covered peaks, quiet monasteries, deep valleys, winding mountain roads and communities whose traditions remain deeply connected to the landscape.",
    seo: "Sikkim Travel | Curated Himalayan Journeys | Urban Trail",
    editorial: [
      {
        label: "The Landscape",
        title: "Peaks that hold the morning light.",
        text: "From the first glow on the Kanchenjunga range to valleys wrapped in mist, Sikkim's landscapes unfold slowly. We shape days that begin with the light and leave space to simply stand still and take it in.",
        image: pex(23022578, 1600),
      },
      {
        label: "The Culture",
        title: "Monasteries, prayer flags and quiet ritual.",
        text: "Centuries of Himalayan Buddhist tradition live on in Sikkim's monasteries, festivals and mountain communities. We help you encounter them with the respect and unhurried attention they deserve.",
        image: uns("photo-1543341724-c6f823532cac", 1600),
      },
      {
        label: "The Journey",
        title: "Roads that reward patience.",
        text: "In Sikkim, the road is part of the destination — winding climbs, tea stalls with a view, and valleys that appear without warning. We plan routes that leave room for the journey itself.",
        image: uns("photo-1685428081741-a9710684f7ef", 1600),
      },
    ],
    experiences: [
      { title: "Mountain Mornings", text: "Wake early for first light on the high peaks.", image: pex(23022578, 1200) },
      { title: "Monastery Trails", text: "Walk the quiet paths between hilltop monasteries.", image: uns("photo-1634308670152-17f7f1aa4e79", 1200) },
      { title: "Himalayan Roads", text: "Wind through valleys on roads made for slow travel.", image: uns("photo-1685428081741-a9710684f7ef", 1200) },
      { title: "Local Culture", text: "Meet the traditions and tables of mountain communities.", image: uns("photo-1706777568411-27299edbdb28", 1200) },
      { title: "Valley Escapes", text: "Still water, deep forests and hidden valleys.", image: uns("photo-1569734149321-df7bf00caff6", 1200) },
      { title: "Quiet Stays", text: "Beautifully placed stays with the mountains at your window.", image: pex(30151209, 1200) },
    ],
    feature: {
      image: uns("photo-1687074106203-f3dad46d9eb6", 2200),
      overlay: "Follow the mountains.",
    },
    ctaTitle: "Ready to discover Sikkim?",
    ctaButton: "Plan Your Sikkim Journey",
  },
  {
    slug: "arunachal-pradesh",
    name: "Arunachal Pradesh",
    region: "Domestic",
    tagline: "A remote Himalayan world of dramatic landscapes, ancient cultures and unforgettable roads.",
    cardImage: uns("photo-1745780264153-741aa8260944", 1400),
    heroImage: uns("photo-1776834831114-77b5616f09cb", 2200),
    heroTitle: ["Arunachal", "Pradesh"],
    heroSub: "Into the wild heart of the Eastern Himalayas.",
    intro:
      "Arunachal Pradesh remains one of the Himalaya's last great frontiers — a land of high passes, dense forests, glacial rivers and monasteries that have watched over the valleys for centuries.",
    seo: "Arunachal Pradesh Travel | Himalayan Journeys | Urban Trail",
    editorial: [
      {
        label: "The Landscape",
        title: "Where the Eastern Himalayas run wild.",
        text: "Snowbound passes, forested ridges and rivers the colour of glacier ice — Arunachal's scale humbles every itinerary. We build journeys that match its pace, not the other way around.",
        image: uns("photo-1620236232016-3eb7bc6ede3d", 1600),
      },
      {
        label: "The Culture",
        title: "Ancient traditions, living communities.",
        text: "From the great monastery at Tawang to the villages of the high valleys, Arunachal's cultures are not exhibits — they are hosts. We introduce you thoughtfully.",
        image: uns("photo-1628070018796-a9f4e2dd482a", 1600),
      },
      {
        label: "The Journey",
        title: "Some of Asia's great road journeys.",
        text: "The roads to Tawang and beyond are journeys in their own right — long, dramatic and unforgettable. Comfortable vehicles, patient drivers and well-chosen stops make all the difference.",
        image: uns("photo-1640962501301-2f89032c7e88", 1600),
      },
    ],
    experiences: [
      { title: "High Passes", text: "Cross the snow lines of the Eastern Himalaya.", image: uns("photo-1668437824006-1be44600774b", 1200) },
      { title: "Monastery Mornings", text: "Prayer halls and courtyards above the clouds.", image: uns("photo-1785163911380-312d26ee1757", 1200) },
      { title: "River Valleys", text: "Follow glacial rivers through deep gorges.", image: pex(29190869, 1200) },
      { title: "Living Traditions", text: "Festivals, crafts and mountain hospitality.", image: uns("photo-1602020234671-15fd6180428d", 1200) },
      { title: "Forest Trails", text: "Walk beneath canopies older than the roads.", image: uns("photo-1626761627604-f27d98885f4b", 1200) },
      { title: "Mountain Lodges", text: "Simple, warm stays in remarkable settings.", image: pex(30728582, 1200) },
    ],
    feature: {
      image: uns("photo-1662551392187-768334a36d4e", 2200),
      overlay: "Beyond the familiar.",
    },
    ctaTitle: "Ready to discover Arunachal Pradesh?",
    ctaButton: "Plan Your Arunachal Journey",
  },
  {
    slug: "bali",
    name: "Bali",
    region: "International",
    tagline: "Tropical landscapes, island culture and beautifully unhurried escapes.",
    cardImage: uns("photo-1577717903315-1691ae25ab3f", 1400),
    heroImage: uns("photo-1518548419970-58e3b4079ab2", 2200),
    heroTitle: ["Bali"],
    heroSub: "An island of rhythm, ritual and endless discovery.",
    intro:
      "Bali rewards those who slow down. Beyond the postcards lies an island of temple ceremonies at dawn, rice terraces folded into hillsides, and a hospitality culture that turns a stay into a relationship.",
    seo: "Bali Travel | Curated Island Journeys | Urban Trail",
    editorial: [
      {
        label: "Island Life",
        title: "Terraces, palms and unhurried days.",
        text: "The emerald staircases of Tegallalang and the quiet lanes of the island's interior reveal a Bali that moves to its own rhythm. We design days around that rhythm.",
        image: uns("photo-1555400038-63f5ba517a47", 1600),
      },
      {
        label: "Culture & Heritage",
        title: "An island that prays in public.",
        text: "Daily offerings, temple gates framing volcano views, ceremonies that stop traffic — Balinese culture is lived, not performed. We help you witness it gracefully.",
        image: uns("photo-1537953773345-d172ccf13cf1", 1600),
      },
      {
        label: "Wellness & Relaxation",
        title: "The art of doing very little, beautifully.",
        text: "Long breakfasts, warm water, skilled hands and shaded terraces. Bali's gift is restoration — we simply make sure nothing interrupts it.",
        image: uns("photo-1546484475-7f7bd55792da", 1600),
      },
    ],
    experiences: [
      { title: "Rice Terrace Walks", text: "Early mornings in the island's green heart.", image: uns("photo-1558005530-a7958896ec60", 1200) },
      { title: "Temple Golden Hours", text: "Sacred sites at their most atmospheric.", image: uns("photo-1711609110590-5ad5c4599e56", 1200) },
      { title: "Hidden Beaches", text: "White sand and turquoise water below the cliffs.", image: uns("photo-1573790387438-4da905039392", 1200) },
      { title: "Jungle Waterfalls", text: "Cool water at the end of a forest path.", image: uns("photo-1554931670-4ebfabf6e7a9", 1200) },
      { title: "Private Villas", text: "Stays designed around privacy and light.", image: pex(16573669, 1200) },
      { title: "Island Play", text: "Swings, surf and the simple joy of warm air.", image: uns("photo-1554481923-a6918bd997bc", 1200) },
    ],
    feature: {
      image: uns("photo-1711609110590-5ad5c4599e56", 2200),
      overlay: "An island of rhythm.",
    },
    ctaTitle: "Ready to discover Bali?",
    ctaButton: "Plan Your Bali Journey",
  },
  {
    slug: "dubai",
    name: "Dubai",
    region: "International",
    tagline: "Contemporary luxury, extraordinary architecture and experiences at every turn.",
    cardImage: uns("photo-1518684079-3c830dcef090", 1400),
    heroImage: uns("photo-1512453979798-5ea266f8880c", 2200),
    heroTitle: ["Dubai"],
    heroSub: "Where extraordinary becomes everyday.",
    intro:
      "Dubai is a city that reimagines itself constantly — a skyline that glows at dusk, a desert that begins where the roads end, and a standard of hospitality that treats the exceptional as routine.",
    seo: "Dubai Travel | Curated City Journeys | Urban Trail",
    editorial: [
      {
        label: "City & Architecture",
        title: "A skyline written in glass and light.",
        text: "From the Burj Khalifa to the Marina, Dubai's architecture is best experienced slowly — from the water, at twilight, and from above. We time it right.",
        image: uns("photo-1708361089093-beef4c4584e7", 1600),
      },
      {
        label: "Desert Experiences",
        title: "The silence beyond the city.",
        text: "An hour from the towers, the dunes take over. Private desert evenings, camel trains at golden hour and dinners under a sky full of stars.",
        image: uns("photo-1528702748617-c64d49f918af", 1600),
      },
      {
        label: "Dining & Evenings",
        title: "Nights above the city.",
        text: "Rooftop tables, marina-side dinners and some of the most ambitious kitchens in the region. We reserve the seats worth reserving.",
        image: uns("photo-1739900292622-a7f860175aad", 1600),
      },
    ],
    experiences: [
      { title: "Iconic Views", text: "The Burj Khalifa, framed and floodlit.", image: uns("photo-1634007626524-f47fa37810a7", 1200) },
      { title: "Modern Icons", text: "Architecture as spectacle, from the Frame to the future.", image: uns("photo-1628859017536-c2f1d69f3c84", 1200) },
      { title: "The Marina", text: "Waterfront promenades and golden-hour towers.", image: uns("photo-1580674684081-7617fbf3d745", 1200) },
      { title: "Desert Evenings", text: "Dunes, camels and a sky full of stars.", image: uns("photo-1528702748617-c64d49f918af", 1200) },
      { title: "Shopping Districts", text: "From grand malls to old-souk textures.", image: uns("photo-1546412414-8035e1776c9a", 1200) },
      { title: "City Nights", text: "Skyline views that never quite switch off.", image: uns("photo-1510665724063-f77a01074aa2", 1200) },
    ],
    feature: {
      image: uns("photo-1708361089093-beef4c4584e7", 2200),
      overlay: "Extraordinary, everyday.",
    },
    ctaTitle: "Ready to discover Dubai?",
    ctaButton: "Plan Your Dubai Journey",
  },
];

export const ARTICLES = [
  {
    slug: "the-first-light-of-sikkim",
    category: "Sikkim",
    title: "The First Light of Sikkim",
    excerpt:
      "A visual journey through Himalayan mornings, quiet valleys and mountain roads.",
    author: "Urban Trail Editorial",
    date: "Journal · 2026",
    hero: pex(30701907, 2200),
    body: [
      {
        type: "p",
        text: "There is a particular hour in the Himalayas when the mountains belong to no one. The valleys are still wrapped in shadow, the roads are empty, and the first light arrives not as a flood but as a touch — a line of gold drawn slowly across the highest snow.",
      },
      { type: "h2", text: "Mornings above the clouds" },
      {
        type: "p",
        text: "In Sikkim, mornings are an event. The Kanchenjunga range catches the sun long before the towns below wake, and for a few minutes the peaks burn against a sky the colour of deep water. It is the kind of spectacle that rewards those willing to rise early, wrap their hands around a warm cup, and simply watch.",
      },
      {
        type: "img",
        src: pex(12174800, 1800),
        caption: "First light on the Kanchenjunga range.",
      },
      {
        type: "p",
        text: "What makes these mornings memorable is not only the view but the silence around it. Prayer flags stir. A monastery bell carries across the valley. The day begins the way the mountains intend it to — slowly.",
      },
      { type: "h2", text: "Roads that reward patience" },
      {
        type: "p",
        text: "Sikkim's roads are not the fastest way between two points, and that is precisely their gift. They wind through forests and along ridges, pausing at tea stalls with views that no viewpoint sign could improve upon. Travelling here teaches you that the space between destinations is not empty — it is where the journey lives.",
      },
      {
        type: "img",
        src: uns("photo-1685428081741-a9710684f7ef", 1800),
        caption: "The long way is often the right way.",
      },
      { type: "quote", text: "The best journeys are rarely measured in kilometres." },
      {
        type: "p",
        text: "When you are ready to see the first light for yourself, tell us when you would like to travel. We will shape the mornings around you.",
      },
    ],
  },
  {
    slug: "beyond-the-familiar-arunachal-pradesh",
    category: "Arunachal Pradesh",
    title: "Beyond the Familiar: Discovering Arunachal Pradesh",
    excerpt:
      "High passes, ancient monasteries and one of the Himalaya's last great frontiers.",
    author: "Urban Trail Editorial",
    date: "Journal · 2026",
    hero: uns("photo-1776834831114-77b5616f09cb", 2200),
    body: [
      {
        type: "p",
        text: "Some destinations reveal themselves quickly. Arunachal Pradesh is not one of them. India’s easternmost Himalayan state keeps its treasures at the end of long roads — and asks, in return, only that you arrive with time and curiosity.",
      },
      { type: "h2", text: "The far eastern heights" },
      {
        type: "p",
        text: "The journey toward Tawang climbs through forests that thin into high, wind-carved passes. Prayer flags appear at the roadside long before any settlement does — a quiet signal that you have entered a landscape where the sacred and the everyday share the same ground.",
      },
      {
        type: "img",
        src: uns("photo-1620236232016-3eb7bc6ede3d", 1800),
        caption: "Ridges and valleys of the Eastern Himalaya.",
      },
      {
        type: "p",
        text: "The monastery at Tawang sits above the valley like a village of its own — whitewashed walls, golden roofs, and courtyards where young monks debate in the afternoon sun. It has watched over these mountains for centuries, and it does not hurry for anyone.",
      },
      { type: "h2", text: "A different kind of luxury" },
      {
        type: "p",
        text: "In Arunachal, luxury is not thread counts and tasting menus. It is a warm room after a long pass, a valley entirely to yourself, a conversation with a host whose family has farmed the same slopes for generations. It is the rare feeling of being somewhere the world has not yet rushed.",
      },
      {
        type: "img",
        src: uns("photo-1785163911380-312d26ee1757", 1800),
        caption: "Golden roofs and prayer flags above the valley.",
      },
      { type: "quote", text: "The further the road, the deeper the remembering." },
      {
        type: "p",
        text: "Arunachal Pradesh is not for every traveller — and that is exactly why it stays with the ones who go. If you are one of them, we would be glad to plan the road with you.",
      },
    ],
  },
  {
    slug: "plan-a-journey-that-doesnt-feel-like-a-package",
    category: "Travel",
    title: "How to Plan a Journey That Doesn't Feel Like a Package",
    excerpt:
      "Fewer places, better pacing, and room for the unplanned — the anatomy of a journey that feels like yours.",
    author: "Urban Trail Editorial",
    date: "Journal · 2026",
    hero: uns("photo-1734699762001-ea94ad09800c", 2200),
    body: [
      {
        type: "p",
        text: "You know the feeling of a packaged trip within the first day: the flagged meeting points, the fifteen-minute photo stops, the sense of being processed rather than hosted. A good journey feels nothing like that. It feels like it was always meant for you.",
      },
      { type: "h2", text: "Choose depth over coverage" },
      {
        type: "p",
        text: "The single most powerful decision in travel planning is subtraction. Three nights in one valley will give you more than one night in three valleys. Depth lets a place stop being a backdrop and start being a relationship — the café that learns your order, the trail you walk twice because the light was different.",
      },
      {
        type: "img",
        src: uns("photo-1558005530-a7958896ec60", 1800),
        caption: "Slow mornings in the rice terraces.",
      },
      { type: "h2", text: "Plan the rhythm, not just the route" },
      {
        type: "p",
        text: "Great itineraries breathe. A demanding day on the road is followed by a morning with nothing scheduled. A big-ticket sight is balanced by an unscripted afternoon. When every hour is accounted for, nothing has room to surprise you — and surprise is the raw material of memory.",
      },
      {
        type: "img",
        src: uns("photo-1546484475-7f7bd55792da", 1800),
        caption: "Leave space for the afternoon that was never on the itinerary.",
      },
      { type: "quote", text: "A journey should be designed the way a good host plans an evening — thoughtfully, invisibly, and entirely around the guest." },
      {
        type: "p",
        text: "This is how we work at Urban Trail: we begin with your pace, your interests and your idea of a day well spent — and shape everything else from there. When you are ready, the first conversation costs nothing but a few minutes.",
      },
    ],
  },
];

export const destinationBySlug = (slug) =>
  DESTINATIONS.find((d) => d.slug === slug);

export const articleBySlug = (slug) => ARTICLES.find((a) => a.slug === slug);
